import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, UserCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet';

export const Navbar = ({ user, onLogout }) => {
  const navLinks = [
    { to: '/courses', label: 'Cursos' },
    { to: '/becas', label: 'Becas' },
    { to: '/articulos', label: 'Artículos' },
    { to: '/delegates', label: 'Delegados' },
    { to: '/verify', label: 'Verificar Certificado' },
    { to: '/about', label: 'Nosotros' },
    { to: '/contact', label: 'Contacto' },
  ];

  return (
    <nav className="border-b bg-white/80 backdrop-blur-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <img 
              src="/logo-transparent.png" 
              alt="IAASP Logo" 
              className="h-12 w-auto object-contain"
            />
            <span className="text-xl font-heading font-bold text-primary">IAASP Academy</span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-sm font-medium text-foreground hover:text-accent transition-colors"
                data-testid={`nav-${link.label.toLowerCase()}`}
              >
                {link.label}
              </Link>
            ))}
            {user ? (
              <div className="flex items-center gap-3">
                <Link to="/dashboard" data-testid="dashboard-link">
                  <Button variant="outline" size="sm">Dashboard</Button>
                </Link>
                <Link to="/profile" data-testid="profile-link">
                  <Button variant="ghost" size="sm" className="gap-1.5">
                    <UserCircle className="w-4 h-4" />Mi Perfil
                  </Button>
                </Link>
                <Button variant="ghost" size="sm" onClick={onLogout} data-testid="logout-btn">
                  Salir
                </Button>
              </div>
            ) : (
              <div className="flex items-center gap-3">
                <Link to="/login" data-testid="login-link">
                  <Button variant="outline" size="sm">Iniciar Sesión</Button>
                </Link>
                <Link to="/register" data-testid="register-link">
                  <Button size="sm">Registrarse</Button>
                </Link>
              </div>
            )}
          </div>

          {/* Mobile Nav */}
          <Sheet>
            <SheetTrigger asChild className="md:hidden">
              <Button variant="ghost" size="icon" data-testid="mobile-menu-btn">
                <Menu className="w-5 h-5" />
              </Button>
            </SheetTrigger>
            <SheetContent>
              <div className="flex flex-col gap-4 mt-8">
                {navLinks.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className="text-sm font-medium text-foreground hover:text-accent transition-colors"
                  >
                    {link.label}
                  </Link>
                ))}
                {user ? (
                  <>
                    <Link to="/dashboard">
                      <Button variant="outline" className="w-full">Dashboard</Button>
                    </Link>
                    <Link to="/profile">
                      <Button variant="outline" className="w-full">Mi Perfil</Button>
                    </Link>
                    <Button variant="ghost" onClick={onLogout} className="w-full">Salir</Button>
                  </>
                ) : (
                  <>
                    <Link to="/login">
                      <Button variant="outline" className="w-full">Iniciar Sesión</Button>
                    </Link>
                    <Link to="/register">
                      <Button className="w-full">Registrarse</Button>
                    </Link>
                  </>
                )}
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </nav>
  );
};
